import React from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import AllOrderTable from "../AllOrderTable/AllOrderTable";
import { useEffect } from "react";
import { useState } from "react";
import { getAllOrderApi } from "../../../Api/PanelAdminServices";
import { Modal } from "react-bootstrap";
import UserInfo from "../../Modal/Information/UserInfo/UserInfo";
import OrderListAll from "../../Modal/Information/OrderListAll/OrderListAll";
import PayingToWho from "../../Modal/Information/PayingToWho/PayingToWho";
import DeliveryInfo from "../../Modal/Information/DeliveryInfo/DeliveryInfo";
import NewFactor from "../../Modal/Information/NewFactor/NewFactor";
import { errorToast } from "../../../Utils/Toast/Toast";
import { calculateOrderTotals } from "../../../Utils/Helper/Helper";

const NotPaidOrderContainer = () => {
  const [orders, setOrders] = useState([]);
  const [orderDetail, setOrderDetail] = useState([]);
  const [isOrderVisible, setIsOrderVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalDeliver, setModalDeliver] = useState(false);
  const [payingModal, setPayingModal] = useState(false);
  const [newFactorModal, setNewFactorModal] = useState(false);
  useEffect(() => {
    getAcceptedSupplier();
  }, []);

  const getAcceptedSupplier = async () => {
    getAllOrderApi("not_paid",(succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setOrders(res.orders);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  const showModal = async (id, info) => {
    setOrderDetail(info);
    //////// user Info /////////
    if (id === 1) {
      setIsModalVisible(true);
    }

    //////// order List ////////
    if (id === 2) {
      setIsOrderVisible(true);
    }

    //////// pay to who ////////
    if (id === 3) {
      setPayingModal(true);
    }

    //////// peyk info ////////
    if (id === 4) {
      setModalDeliver(true);
    }

    //////// new factor ////////
    if (id === 5) {
      setNewFactorModal(true);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setIsOrderVisible(false);
    setPayingModal(false);
    setModalDeliver(false);
    setNewFactorModal(false);
  };

  const dataList = orders.map((element) => {
    return calculateOrderTotals(element);
  });

  const data =
    dataList &&
    dataList.map((item, index) => {
      return {
        ...item,
        key: index,
        person: item.first_name + " " + item.last_name,
        orderNumber: item.id,
      };
    });
  data.sort((a, b) => b.orderNumber - a.orderNumber);
  /////// style /////////
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
    fontSize: "1.1rem",
    fontFamilly: "iran-sans",
  };
  return (
    <div>
      <Modal show={isModalVisible} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات مشتری</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserInfo Info={orderDetail} showAddress={true} handleOk={handleOk} />
        </Modal.Body>
      </Modal>

      <Modal show={isOrderVisible} onHide={handleOk} size="xl">
        <Modal.Header>
          <Modal.Title style={TitleStyle}>لیست سفارش</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderListAll Info={orderDetail} item={orderDetail} handleOk={handleOk} />
        </Modal.Body>
      </Modal>

      <Modal show={newFactorModal} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>فاکتور جدید</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewFactor info={orderDetail} />
        </Modal.Body>
      </Modal>

      <Modal show={modalDeliver} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات پیک</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DeliveryInfo Info={orderDetail.deliver} handleOk={handleOk} />
        </Modal.Body>
      </Modal>

      <Modal show={payingModal} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>ترکنشات کیف پول</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PayingToWho data={orderDetail} handleOk={handleOk} />
        </Modal.Body>
      </Modal>
      <TableFixedPage title={" سفارشات پرداخت نشده"} />
      <AllOrderTable showModal={showModal} data={data} />
    </div>
  );
};

export default NotPaidOrderContainer;
